import { useTranslation } from "react-i18next";
import { Sparkles } from "lucide-react";
import { getBlueprintTheme } from "../../Blueprints/blueprintThemes";

export function AiRecommendedSkeleton() {
    const { t } = useTranslation();
    return (
        <div
            className="relative bg-gradient-to-br from-indigo-50 via-white to-purple-50 border-2 border-transparent rounded-xl p-5 animate-pulse"
            style={{ borderImage: "linear-gradient(135deg, #6366f1, #a855f7, #6366f1) 1" }}
        >
            <div className="flex items-center gap-1.5 text-indigo-400 text-xs font-semibold mb-3">
                <Sparkles className="h-3.5 w-3.5 animate-spin" style={{ animationDuration: "3s" }} />
                {t("chatPage.aiRecommendedLoading", { defaultValue: "Finding the perfect template for you..." })}
            </div>
            <div className="flex items-start gap-3">
                <div className="bg-indigo-100 p-2.5 rounded-lg flex-shrink-0 w-11 h-11" />
                <div className="flex-1 min-w-0">
                    <div className="bg-indigo-100 h-5 w-2/3 rounded mb-2" />
                    <div className="bg-indigo-100/70 h-3 w-full rounded mb-1.5" />
                    <div className="bg-indigo-100/70 h-3 w-4/5 rounded" />
                </div>
            </div>
        </div>
    );
}

export default function AiRecommendedCard({ blueprint, reason, onClick }) {
    const { t } = useTranslation();
    const { Icon, colors } = getBlueprintTheme(blueprint);

    return (
        <div
            className="relative bg-gradient-to-br from-indigo-50 via-white to-purple-50 border-2 border-transparent rounded-xl p-5 hover:shadow-lg transition-all cursor-pointer group"
            style={{ borderImage: "linear-gradient(135deg, #6366f1, #a855f7, #6366f1) 1" }}
            onClick={() => onClick(blueprint)}
        >
            <div className="flex items-center gap-1.5 text-indigo-600 text-xs font-semibold mb-3">
                <Sparkles className="h-3.5 w-3.5" />
                {t("chatPage.aiRecommended", { defaultValue: "AI Recommended for you" })}
            </div>
            <div className="flex items-start gap-3">
                <div className="bg-white/80 p-2.5 rounded-lg group-hover:bg-white transition-colors flex-shrink-0 shadow-sm">
                    <Icon className={`h-6 w-6 ${colors.icon}`} />
                </div>
                <div className="flex-1 min-w-0">
                    <h4 className="font-semibold text-gray-900 mb-1 text-base">{blueprint.name}</h4>
                    <p className="text-sm text-gray-600 line-clamp-2">{blueprint.description || ""}</p>
                    {reason ? <p className="text-xs text-indigo-500 mt-2 italic">{reason}</p> : null}
                </div>
            </div>
        </div>
    );
}
